class Utils {
    static $inject = ['$filter'];

    /**
     * @param {ng.IFilterService} $filter
     */
    constructor($filter) {
        const orderBy = $filter('orderBy');

        Array.prototype.orderBy = function (expression, reverse, comparator) {
            return orderBy(this, expression, reverse, comparator);
        }

        Array.prototype.groupBy = function (prop) {
            return this.reduce(function (groups, item) {
                var val = item[prop];
                groups[val] = groups[val] || [];
                groups[val].push(item);
                return groups;
            }, {});
        }

        // used by working directive
        angular.element.prototype.closest = function closest(selector) {
            if (selector && selector.length) {
                const startChar = selector.substring(0, 1);
                switch (startChar) {
                    case '.':
                        return this.hasClass(selector.substring(1, selector.length)) ? this : (this.parent().length ? this.parent().closest(selector) : this.parent());

                    case '#':
                        return selector.substring(1, selector.length) == this[0].id ? this : (this.parent().length ? this.parent().closest(selector) : this.parent());

                    default: //tagname
                        return (this[0].tagName && selector.toLowerCase() == this[0].tagName.toLowerCase()) ? this : (this.parent().length ? this.parent().closest(selector) : this.parent());
                }
            }
            else {
                return this.parent();
            }
        }
    }
}

angular
    .module('app')
    .service('utils', Utils)
    .run(['utils', utils => { }]); // instantiate the service so the constructor runs and creates the Array functions